





















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { QuestionFileModel } from "survey-core";
@Component
export class FilePreview extends Vue {
  @Prop() question: QuestionFileModel;
}
Vue.component("sv-file-preview", FilePreview);
export default FilePreview;
